import * as React from 'react';

import { createIcon } from '../Icon';
export const CreditCardIcon = createIcon(
  <React.Fragment>
    <rect height={16} rx={2} ry={2} width={22} x={1} y={4} />
    <line x1={1} x2={23} y1={10} y2={10} />
  </React.Fragment>,
  'CreditCardIcon'
);
